import { Link } from 'react-router-dom';
import Icon from '@/components/primitives/Icon.jsx';
import AUTOMATION_KINDS from '../lib/AUTOMATION_KINDS.js';
import AutomationActiveSwitch from './AutomationActiveSwitch.jsx';

/** One automation in the list: what kind it is, its name, when it runs and when it runs next, what it does, and whether it is on. */
const AutomationRow = ({ automation }) => {
  const kind = AUTOMATION_KINDS[automation.kind];
  const href = automation.isPlanning ? `/threads/${automation.threadId}` : `/automations/${automation.kind}/${automation.id}`;

  return (
    <li className="automations-row">
      <span className="automations-row__kind" title={kind.singular}>
        <Icon icon={kind.icon} label={kind.singular} />
      </span>
      <div className="automations-row__text">
        <Link className="automations-row__name" to={href}>
          {automation.name}
        </Link>
        <p className="automations-row__when">
          {automation.when}
          {automation.nextRun && <span className="automations-row__next">Next run {automation.nextRun}</span>}
        </p>
        {automation.what && <p className="automations-row__what">{automation.what}</p>}
      </div>
      <div className="automations-row__state">
        <AutomationActiveSwitch automation={automation} />
      </div>
    </li>
  );
};

export default AutomationRow;
